.inlineButton {
  background: none;
  border: 0;
  color: var(--pgm-sys-color-secondary);
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: underline;
}

.inlineButton:hover,
.inlineButton:focus {
  color: color-mix(
    in srgb,
    var(--pgm-sys-color-on-surface) 52%,
    var(--pgm-sys-color-secondary)
  );
}

.inlineButton:focus-visible {
  border-radius: 4px;
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}
